<template>
    <rkm-col cols="12">
        <rkm-area
            type="fieldset"
            title="Práticas em saúde"
            v-if="showPratica"
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-checkbox-group
                        v-model="data.model.saudePratica"
                        name="Práticas em saúde"
                        :validations="validations.pratica"
                    >
                        <rkm-form-checkbox
                            v-for="item in data.form.saudePratica"
                            :key="item.id"
                            cols="6"
                            :value="item.id"
                            :disabled="isPraticaDisabled(item.id)"
                            class="w-50 m-0"
                        >
                            {{ item.descricao }}
                        </rkm-form-checkbox>
                    </rkm-form-checkbox-group>
                </rkm-col>
            </rkm-row>
            <rkm-row>
                <rkm-col cols="6"></rkm-col>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="data.form.procedimentosColetivos"
                        show-default-option
                        default-option-text=""
                        text-field="descricao"
                        v-model="data.model.procedimentoColetivoId"
                        value-field="id"
                        class="mt-2"
                        :disabled="!data.model.saudePratica.includes(this.enums.saudePratica.OUTRO_PROCEDIMENTO_COLETIVO)"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </rkm-col>
</template>

<script>

//Enums
import atividadeTipo from '@/enums/atencao-basica/atividade-coletiva/atividadeTipo'
import saudePratica from '@/enums/atencao-basica/atividade-coletiva/saudePratica'
import pse from '@/enums/atencao-basica/atividade-coletiva/pse'

export default {
    data: () => ({
        enums: {
            atividadeTipo,
            saudePratica,
            pse
        }
    }),
    methods: {
        isPraticaDisabled(id) {
            if(this.data.model.atividade.atividadeTipoId == this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO) {
                return id == this.enums.saudePratica.APLICACAO_TOPICA_DE_FLUOR || id == this.enums.saudePratica.ESCOVACAO_DENTAL_SUPERVISIONADA
            }

            if(this.data.model.cadastro.pseId == this.enums.pse.EDUCACAO) {
                return id == this.enums.saudePratica.APLICACAO_TOPICA_DE_FLUOR || id == this.enums.saudePratica.ESCOVACAO_DENTAL_SUPERVISIONADA || id == this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_1 || id == this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_2 || id == this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_3 || id == this.enums.saudePratica.PROGRAMA_NACIONAL_DE_CONTROLE_DO_TABAGISMO_4 || id == this.enums.saudePratica.VERIFICACAO_DA_SITUACAO_VACINAL || id == this.enums.saudePratica.OUTRO_PROCEDIMENTO_COLETIVO
            }
        },
    },
    computed: {
        showPratica() {
            const atividadeTipoId = this.data.model.atividade.atividadeTipoId

            const tiposAtividade = [
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO
            ]
            
            return this.data.model.saudePratica && tiposAtividade.includes(atividadeTipoId)
            
        },
        validations() {
            return {
                pratica: {
                    required: this.isRequiredPratica,
                }
            }
        },
        isRequiredPratica() {
            const tiposAtividade = [
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO
            ]

            return tiposAtividade.includes(this.data.model.atividade.atividadeTipoId)
        }
    },
    watch: {
        'data.model.atividade.atividadeTipoId': function (atividade) {

            const atividadeTipoId = atividade

            const tiposAtividade = [
                this.enums.atividadeTipo.ATENDIMENTO_EM_GRUPO,
                this.enums.atividadeTipo.AVALIACAO_PROCEDIMENTO_COLETIVO
            ]

            if (!tiposAtividade.includes(atividadeTipoId)) {
                this.data.model.saudePratica = []
            }

        },
        'data.model.saudePratica': function (pratica) {

            const praticaId = pratica

            if(!praticaId.includes(this.enums.saudePratica.OUTRO_PROCEDIMENTO_COLETIVO)) {
                this.data.model.procedimentoColetivoId = null
            }


        }
    },    
    props: {
        data: { type: Object, required: false, },
    }
}
</script>